export default "__VITE_ASSET__GoZs53si__"